import React from 'react';
import { Grid, ArrowRight } from 'lucide-react';
import * as LucideIcons from 'lucide-react';

/**
 * Компонент галереи форм помещений
 */
const RoomShapesGallery = ({ roomShapes, setFormData, currentShape }) => {
  // Динамическое получение иконок из библиотеки Lucide
  const getIconComponent = (iconName) => {
    const IconComponent = LucideIcons[iconName];
    return IconComponent ? <IconComponent className="w-6 h-6" /> : <Grid className="w-6 h-6" />;
  };
  
  // Обработчик выбора формы комнаты
  const handleShapeSelect = (shapeId) => {
    setFormData(prev => ({
      ...prev,
      roomShape: shapeId
    }));
  };
  
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 mt-8">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Grid className="w-5 h-5 mr-2 text-fuchsia-500" />
        Доступные формы помещений
      </h3>
      
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {roomShapes.map((shape) => (
          <div 
            key={shape.id}
            className={`p-4 rounded-lg border cursor-pointer transition-colors flex flex-col items-center ${
              currentShape === shape.id 
                ? 'bg-fuchsia-50 border-fuchsia-200 dark:bg-fuchsia-900/20 dark:border-fuchsia-600'
                : 'bg-gray-50 border-gray-200 dark:bg-gray-700 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-650'
            }`}
            onClick={() => handleShapeSelect(shape.id)}
          >
            <div className="w-12 h-12 rounded-full bg-fuchsia-100 dark:bg-fuchsia-900/40 flex items-center justify-center mb-2 text-fuchsia-600 dark:text-fuchsia-300">
              {getIconComponent(shape.icon)}
            </div>
            <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 text-center">{shape.name}</h4>
            <p className="text-xs text-gray-500 dark:text-gray-400 text-center mt-1 hidden sm:block">
              {shape.id === 'rectangle' ? 'Самая распространённая форма помещения' :
               shape.id === 'l-shaped' ? 'Для Г-образных комнат и студий' :
               shape.id === 'angled' ? 'Для комнат со скошенным углом' :
               shape.id === 'bay-window' ? 'Учитывает выступающий эркер' :
               shape.id === 'niche' ? 'С нишей в стене для мебели' :
               shape.id === 'column' ? 'Учитывает колонну в помещении' :
               shape.id === 'polygon' ? 'Произвольная многоугольная форма' :
               'Для круглых и полукруглых комнат'}
            </p>
          </div>
        ))}
      </div>
      
      <div className="mt-6 p-4 rounded-lg bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600">
        <div className="flex items-start gap-4">
          <div className="hidden sm:block mt-1">
            <ArrowRight className="w-6 h-6 text-fuchsia-500" />
          </div>
          <div>
            <h4 className="text-base font-medium text-gray-900 dark:text-gray-100 mb-2">Выберите форму, которая наиболее точно соответствует вашему помещению</h4>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              От формы помещения зависит точность расчета площади и количества материалов для ремонта. Для сложных планировок 
              может потребоваться разбить помещение на несколько простых форм и рассчитать их отдельно.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomShapesGallery;